module.exports = __webpack_public_path__ + "img/31.78d8c46d.jpg";